import React, { FC } from 'react';
import Button from '../../ui/Button';
import { useTranslation } from 'react-i18next';
import IconSvg from '../../ui/IconSvg';
import useHistoryBack from '../../../hooks/useHistoryBack';

type OwnProps = {
  name?: string;
  onBack: () => void;
};

const PaymentAiHeader: FC<OwnProps> = ({ name, onBack }) => {
  const { t } = useTranslation();

  useHistoryBack({ isActive: true, onBack });

  return (
    <div className='MiddleHeader'>
      <div className='middle-header-inner'>
        <div className='setting-info'>
          <Button
            round
            size='smaller'
            color='translucent'
            onClick={onBack}
            ariaLabel={String(t('GoBack'))}
          >
            <i className='icon-svg'>
              <IconSvg name='arrow-left' />
            </i>
          </Button>
          <h4>{t(name ? `PaymentAi.${name}.Title` : 'PaymentAi.Title')}</h4>
        </div>
      </div>
    </div>
  );
};

export default PaymentAiHeader;
